/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import './PdfListModal.scss';
import { ReportModel } from '../../core/models/report';
import { BASE_URL, PATH_PREFIX } from '../../core/config/config';
// import pdfIcon from '../../assets/img/pdf.png';

const PdfListModal = ({ handleClose, reports }: any): JSX.Element => {
  // const [searchTerm, setSearchTerm] = useState<string>();

  const reportsList = reports
    // .filter((item: any) => {
    //   return !searchTerm ? true : new RegExp(searchTerm, 'i').test(item.description);
    // })
    .map((report: ReportModel) => {
      return (
        <li key={report.namePath} className="repport">
          <span className="repport__date">{report.dateCreatePdf}</span>
          <a
            className="repport__title"
            href={`${BASE_URL}${PATH_PREFIX}/?key=${report.userKey}`}
            target="_blank"
            rel="noreferrer"
          >
            {report.description}
          </a>

          {/* <img
            onClick={() => handleDownload(r.namePath)}
            className="repport__download"
            src={pdfIcon}
            alt="download pdf"
            title="download pdf"
          /> */}
        </li>
      );
    });

  return (
    <div className="reports-modal">
      <section className="modal-main">
        <div className="modal-header">
          <button type="button" className="close-modal" onClick={handleClose}>
            &times;
          </button>
          <h2>All reports</h2>
          {/* <input
            type="text"
            placeholder="Search..."
            onChange={(e) => setSearchTerm(e.target.value)}
          /> */}
        </div>
        <div className="modal-body">
          <ul className="pdf-reports">{reportsList}</ul>
        </div>
      </section>
    </div>
  );
};

export default PdfListModal;
